import type { ReviewQueueRoute } from "routes/Customer/Waste/Manifests/useReviewQueueRoute";

import { ManifestReviewDialog } from "routes/Customer/Waste/Manifests/ManifestReviewDialog";

import { TenantFeatureFlagsProvider } from "./TenantFeatureFlagsProvider";

/**
 * The document review the URL is currently pointing at.
 *
 * Addressed rather than held in state: the batch and the place in it come from
 * the query string, so a refresh, a Back press and a pasted link all land on the
 * document the reviewer was actually on. The queue's other dialogs stay in
 * component state — they are single-shot lookups with no position to lose.
 *
 * Wrapped in the batch's own tenant because the queue is cross-tenant and the
 * review is flag-gated: resolved against the staff user's session tenant instead,
 * the flag-gated sections would render against the wrong org.
 */
export function QueuedDocumentReview({ queue }: { queue: ReviewQueueRoute }) {
  // Both are needed to render anything: a tenant with no document is nothing to
  // open, and a document with no tenant would resolve its flags to their
  // defaults and quietly show a different screen from the one that was shared.
  if (queue.currentDocumentId == null || queue.tenantId == null) return null;

  return (
    <TenantFeatureFlagsProvider tenantId={queue.tenantId}>
      <ManifestReviewDialog
        documentIds={queue.documentIds}
        currentDocumentId={queue.currentDocumentId}
        onNavigate={queue.navigate}
        onClose={queue.close}
      />
    </TenantFeatureFlagsProvider>
  );
}
